<Page name="home" 
  infinite
  infiniteDistance={30}
  infinitePreloader={showPreloader}
  onInfinite={loadMore}
  class="recommendation-page page">
    <Header isSidebar={true} isCollapse={!isShowFilter} on:click={toggleSearchDisplay}/>
      <Row class={isShowFilter ? 'page-sidebar' : 'page-no-sidebar'}>
      {#if isShowFilter}
        <div class="sidebar-wrapper" style="background-color: #51a3c1;" in:fly="{{ x: -250, opacity: 1 }}">
          <div style="height:100%;">
            <Filter />
          </div>
        </div>
      {/if}
      <div class="page-content-wrapper">  
        <Block style="min-height: 90vh;">
          <RecommendationList/>
        </Block>
      </div>
    </Row>
    <Row><Footer/></Row>
</Page>
<script>
  import {
    Page,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    List,
    ListItem,
    Button,
    Preloader,
    Link,
    Block,
    Row,
    Col,
    SwipeoutActions,
    SwipeoutButton,
  } from 'framework7-svelte';
  import { pluralize } from '../utils';
  import Header from '../components/Header.svelte';
  import Filter from '../components/Filter.svelte';
  import Footer from '../components/Footer.svelte';
  import FilterGrade from '../components/FilterGrade.svelte';
  import RecommendationList from '../components/RecommendationList.svelte';
  import { getContext, onDestroy, onMount } from 'svelte';
  import { oFilterStore, bIsFilterStore } from '../stores.js';
  import { fade, fly } from 'svelte/transition';
  import { fConvertToInches } from '../utils.js';

  let page = 1;
  let items;
  let currentItem;
  let allowInfinite = true;
  let showPreloader = false;
  // let sQuery = '';
  let oQuery;
  let grade;
  let isShowFilter = true;
  let filterFieldObj;

  // Router component will receive f7route prop with current route data
  export let f7route;

  onMount(() => {
    // output current route data
    oQuery = f7route.query;
    storeQuery();
  });

  $: showPreloader = (items) ? (items.length < 299) ? true : false : false;

  const unsubscribe = oFilterStore.subscribe(obj => {
    filterFieldObj = obj;
	});
  onDestroy(unsubscribe);

  // Store search filters via query
  function storeQuery () {
    if (!oQuery || !filterFieldObj) {return;}
    const arrQueryKeys = oQuery && Object.keys(oQuery);
    if (arrQueryKeys && arrQueryKeys.length > 0) {
      arrQueryKeys.forEach(key => {
        if (filterFieldObj[key] && oQuery[key]) {
          filterFieldObj[key].values = [oQuery[key]];
          if (filterFieldObj[key].options && filterFieldObj[key].options.length > 0) {
            filterFieldObj[key].options.forEach(opt => {
              if (opt.value === oQuery[key]) {
                  opt.isActive = true;
              } else {
                  opt.isActive = false;
              }
            });
          }
        }
      });

      // calculate height
      if (filterFieldObj["height"].values.length < 1 && 
          (filterFieldObj["heightFt"].values.length > 0 ||
          filterFieldObj["heightIn"].values.length > 0)) {
            const heightFtVal = filterFieldObj["heightFt"].values.length > 0 && filterFieldObj["heightFt"].values[0];
            const heightInVal = filterFieldObj["heightIn"].values.length > 0 && filterFieldObj["heightIn"].values[0];
            const heightVal = (heightFtVal || heightInVal) ? fConvertToInches(heightFtVal, heightInVal) : null;
            filterFieldObj.height.values = [heightVal];
          }
      bIsFilterStore.set(true);
      oFilterStore.set(filterFieldObj);
    }
  }

  const data = getContext('epss-app-data');
  
  function toggleSearchDisplay() {
    isShowFilter = !isShowFilter;
  }

  function handleGradeFilter(val) {
    if (val) grade = val;
  }

  function loadMore() {
    if (!allowInfinite) return;
    allowInfinite = false;

    if (!showPreloader) return;
    
    page += 1;
  }
</script>
<style>
.row {
    display: flex;
    flex-wrap: wrap;
}
.search-container {
    flex: 40%;
}
.content-container {
    flex: 60%;
}
</style>